import React from 'react';
import { motion } from 'framer-motion';
const CARDS = [{
  emoji: '😔',
  title: 'Se aburre a los cinco minutos',
  text: 'Las mismas historias “escuchadas mil veces” le entran por un oído y le salen por el otro.'
}, {
  emoji: '📱',
  title: 'Compites contra la pantalla y pierdes',
  text: 'Entre YouTube, los juegos y las historietas de superhéroes, la Biblia tradicional —sin imágenes, con lenguaje difícil— parte con desventaja.'
}, {
  emoji: '😟',
  title: 'No sabes por dónde empezar',
  text: 'Quieres enseñarles la Palabra pero no eres teólogo. Te abruma la tarea: ¿qué historias?, ¿en qué orden?, ¿cómo explicarlas para su edad sin quitarles la verdad?'
}, {
  emoji: '⏳',
  title: 'Sientes que el tiempo se acaba',
  text: 'Ves cómo cada generación se aleja más de Dios. Y sabes que la ventana para sembrar la fe es ahora.'
}];
export function PainSection() {
  return <section className="w-full bg-mist" data-id="element-108" data-mp="2781kgwzh169n">
      <div className="mx-auto max-w-6xl px-4 py-5 md:py-6" data-id="element-109" data-mp="3rn0u1kw1yu76">
        <h2 className="mx-auto max-w-3xl text-center font-display text-3xl font-bold leading-tight text-deep-blue md:text-[40px]" data-id="element-110" data-mp="3rlfzvwdnhd9u">
          Quieres darles la fe. Ellos quieren volver a la pantalla.
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[17px] text-ink/75 md:text-lg" data-id="element-111" data-mp="5f15y8cmwk2a">
          Si intentaste acercar la Biblia a tus hijos o nietos, probablemente ya
          viviste esto:
        </p>

        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2" data-id="element-112" data-mp="38u6otio8egg5">
          {CARDS.map((card, i) => <motion.div key={card.title} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} className="rounded-card border border-card-border bg-white p-6 shadow-soft" data-id="element-113" data-mp="3imceumuxansp" data-mpi={i}>
              <div className="mb-3 flex items-center gap-3" data-id="element-114" data-mp="2l6ot5c1uiy7w">
                <span className="text-3xl" aria-hidden="true" data-id="element-115" data-mp="p4lmwtpguktb">
                  {card.emoji}
                </span>
                <h3 className="font-display text-xl font-bold text-deep-blue" data-id="element-116" data-mp="u1lu57y1xtm0">
                  {card.title}
                </h3>
              </div>
              <p className="text-[16px] text-ink/75" data-id="element-117" data-mp="12v78iq6b18uw">{card.text}</p>
            </motion.div>)}
        </div>

        <p className="mx-auto mt-6 max-w-2xl text-center font-display text-xl italic text-deep-blue md:text-2xl" data-id="element-118" data-mp="65hglspb755c">
          No es que a tu hijo no le interese Dios. Es que nadie le contó Su
          historia en un idioma que él ame.
        </p>
      </div>
    </section>;
}